// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h6 {
  letter-spacing: 0.5px;
  margin: 0;
  font-size: 1rem;
}

.card {
  width: 470px;
  height: 180px;
  /* background-color:  */
  border-radius: 10px;
  padding: 12px;
}

p {
  text-align: justify;
  font-size: 18px;
  margin: 5px;
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 100%;
}

.card-content:hover{
  cursor: pointer;
  color: #af8559;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["h6 {\n  letter-spacing: 0.5px;\n  margin: 0;\n  font-size: 1rem;\n}\n\n.card {\n  width: 470px;\n  height: 180px;\n  /* background-color:  */\n  border-radius: 10px;\n  padding: 12px;\n}\n\np {\n  text-align: justify;\n  font-size: 18px;\n  margin: 5px;\n}\n\n.card-content {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  height: 100%;\n}\n\n.card-content:hover{\n  cursor: pointer;\n  color: #af8559;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
